import { isInBrowser } from './browser'

let gleapReady = false
let gleapInitAttempted = false

const loadGleap = async () => {
  const { default: Gleap } = await import('gleap')
  return Gleap
}

export const initGleap = async () => {
  if (!isInBrowser() || gleapInitAttempted) return
  gleapInitAttempted = true

  const apiKey = process.env.GATSBY_GLEAP_API_KEY
  if (!apiKey) return

  const Gleap = await loadGleap()
  Gleap.initialize(apiKey)
  Gleap.showFeedbackButton(false)
  gleapReady = true
}

export const openGleap = async () => {
  if (!isInBrowser()) return
  await initGleap()
  if (!gleapReady) return

  const Gleap = await loadGleap()
  Gleap.open()
}
